<template>
  <v-card loading height="60px">
    <div class="d-flex align-center">
      <v-img
        class="ml-4"
        :src="require('../../img/icons-generating.gif')"
        max-height="26px"
        max-width="26px"
      ></v-img>
      <v-card-text class="text-xl">{{ processingText }}</v-card-text>
    </div>
    <template slot="progress">
      <v-progress-linear
        color="primary"
        height="5"
        indeterminate
      ></v-progress-linear>
    </template>
  </v-card>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
// Pubsub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { subscribe, unsubscribe } from "@/service/wd_pubsub.js";

//例如: import <组件名称> from  <组建路径>

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    propsText: {
      type: String,
      required: false,
    },
  },
  data() {
    //这里存放数据
    return {
      processingText: "",
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    // Pubsub
    pubCallback(msgName, data) {
      if (msgName == gptPubIds.pubId_Local_Gpt_ProcessingText) {
        this.processingText = data;
      }
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    subscribe(gptPubIds.pubId_Local_Gpt_ProcessingText, this.pubCallback);
  },
  destroyed() {
    unsubscribe(this.pubCallback);
  }, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss"></style>
